import '@talentmesh/ui/globals.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import TMPostHogProvider from './Analytics/TMPostHogProvider';
import App from './App';
import { marketing } from './AppSettings';

if (marketing.gtm_container_id) {
    const tagManagerArgs = {
        gtmId: marketing.gtm_container_id,
    };

    TagManager.initialize(tagManagerArgs);
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

const app = (
    <React.StrictMode>
        <TMPostHogProvider>
            <App />
        </TMPostHogProvider>
    </React.StrictMode>
);

root.render(app);
